import React, { useEffect, useRef, useState } from 'react'
import { getProfileDetails, updateProfile } from '../../utils/APIClient';
import { useForm } from 'react-hook-form';
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces } from '../../utils/Constants';
import { getBase64, showSuccessToast } from '../../utils/commonFunctions';
import axios from 'axios';
import { getOnlyToken } from '../../utils/commonFunctions';
import { Modal, Button } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';

export default function Settings() {

  const [profile, setProfle] = useState([]);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const [previewImage, setPreviewImage] = useState(null);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validate file type
    if (!validTypes.includes(file.type)) {
      alert('Only JPG, JPEG, or PNG files are allowed.');
      return;
    }

    // Validate file size
    if (file.size > maxSize) {
      alert('File size should not exceed 5MB.');
      return;
    }

    try {
      const base64 = await getBase64(file);
      setValue('profile_picture_base64', base64);
      setPreviewImage(base64);
    } catch (error) {
      console.error('Error converting file:', error);
      alert('Failed to upload image. Please try again.');
    }
  };


  const fetchProfile = async () => {
    try {
      const response = await getProfileDetails();
      const responseData = response.data;
      if (response.status === 200) {
        const profile = responseData.profile;
        setProfle(profile);
        setValue('first_name', profile.first_name ? profile.first_name : '');
        setValue('email', profile.email ? profile.email : '');
        setValue('bio', profile.bio ? profile.bio : '');
      } else {
        console.error("Failed to fetch profile:", responseData.message);
      }
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    }
  };

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const profileUpdate = async (data) => {
    // console.log("data", data);
    try {
      const response = await updateProfile(data);
      const responseData = response.data;
      if (response.status === 200) {
        setSuccessMessage(responseData.message || "Profile updated successfully");
        setShowSuccessModal(true);
        fetchProfile();
      } else {
        console.error("Failed to fetch profile:", responseData.message);
      }
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    }
  }

  const [notificationSettings, setNotificationSettings] = useState({
    alerts_status: false,
    in_app_notification_status: false,
    call_summary_status: false,
    data_sharing_status: false,
    two_fa_status: false,
    auto_pay_status: false
  });
  const [notifLoading, setNotifLoading] = useState(false);
  const [notifError, setNotifError] = useState("");
  const [passwordForm, setPasswordForm] = useState({
    old_password: '',
    new_password: '',
    confirm_password: ''
  });

  // SMTP Credentials State
  const [smtpDetails, setSmtpDetails] = useState({
    smpt_host: '',
    smpt_port: '',
    smpt_username: '',
    smpt_password: '',
    smpt_from_email: '',
    use_tls: false
  });
  const [smtpId, setSmtpId] = useState(null);
  const [smtpLoading, setSmtpLoading] = useState(false);
  const [smtpError, setSmtpError] = useState('');

  // Fetch SMTP Details (GET)
  const fetchSmtpDetails = async () => {
    setSmtpLoading(true);
    setSmtpError('');
    const token = getOnlyToken();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    try {
      const res = await axios.get('https://callapi.pranathiss.com/api/auth/smtp-details/', config);
      if (res.status === 200 && res.data && res.data.results) {
        const data = res.data.results;
        setSmtpDetails({
          smpt_host: data.smpt_host || '',
          smpt_port: data.smpt_port || '',
          smpt_username: data.smpt_username || '',
          smpt_password: data.smpt_password || '',
          smpt_from_email: data.smpt_from_email || '',
          use_tls: data.use_tls === true || data.use_tls === 'true' || data.use_tls === 1
        });
        setSmtpId(data.id || null);
      }
    } catch (err) {
      setSmtpError('Failed to fetch SMTP details');
    } finally {
      setSmtpLoading(false);
    }
  };

  // Handle SMTP input change
  const handleSmtpChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSmtpDetails(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Save SMTP Details (POST or PUT)
  const handleSmtpSubmit = async (e) => {
    e.preventDefault();
    setSmtpLoading(true);
    setSmtpError('');
    const token = getOnlyToken();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    const payload = {
      ...smtpDetails,
      smpt_port: Number(smtpDetails.smpt_port)
    };
    try {
      let res;
      if (smtpId) {
        // PUT (update)
        res = await axios.put('https://callapi.pranathiss.com/api/auth/smtp-details/', payload, config);
      } else {
        // POST (create)
        res = await axios.post('https://callapi.pranathiss.com/api/auth/smtp-details/', payload, config);
      }
      if (res.status === 200 || res.status === 201) {
        setSuccessMessage('SMTP details saved successfully');
        setShowSuccessModal(true);
        fetchSmtpDetails();
      }
    } catch (err) {
      setSmtpError('Failed to save SMTP details');
    } finally {
      setSmtpLoading(false);
    }
  };
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");
  const [showPasswords, setShowPasswords] = useState({
    old_password: false,
    new_password: false,
    confirm_password: false
  });
  const [passwordValidationErrors, setPasswordValidationErrors] = useState({});

  // Toggle password visibility
  const togglePasswordVisibility = (field) => {
    setShowPasswords(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  // Validate passwords in real-time
  const validatePasswords = (formData) => {
    const errors = {};
    
    if (!formData.old_password) {
      errors.old_password = "Current password is required";
    }
    
    if (!formData.new_password) {
      errors.new_password = "New password is required";
    } else if (formData.new_password.length < 6) {
      errors.new_password = "New password must be at least 6 characters";
    } else if (formData.new_password === formData.old_password) {
      errors.new_password = "New password must be different from current password";
    }
    
    if (!formData.confirm_password) {
      errors.confirm_password = "Confirm password is required";
    } else if (formData.new_password !== formData.confirm_password) {
      errors.confirm_password = "Passwords do not match";
    }
    
    return errors;
  };

  const fetchNotificationSettings = async () => {
    setNotifLoading(true);
    setNotifError("");
    const token = getOnlyToken();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    try {
      const res = await axios.get('/api/auth/notification-settings/', config);
      if (res.status === 200 && res.data) {
        const apiSettings = res.data.results || {};
        const cleanSettings = { ...notificationSettings };
        Object.keys(cleanSettings).forEach(key => {
          if (typeof apiSettings[key] !== 'undefined') {
            cleanSettings[key] = apiSettings[key] === true || apiSettings[key] === 'true' || apiSettings[key] === 1;
          }
        });
        console.log("Notification Settings:", res.data);

        setNotificationSettings(cleanSettings);
      }
    } catch (err) {
      setNotifError("Failed to fetch notification settings");
    } finally {
      setNotifLoading(false);
    }
  };

  // Update notification settings
  const updateNotificationSettings = async () => {
    setNotifLoading(true);
    setNotifError("");
    const token = getOnlyToken();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    try {
      const res = await axios.put('/api/auth/notification-settings/', notificationSettings, config);
      if (res.status === 200) {
        setSuccessMessage("Notification settings updated successfully");
        setShowSuccessModal(true);
      }
    } catch (err) {
      setNotifError("Failed to update notification settings");
    } finally {
      setNotifLoading(false);
    }
  };

  // Handle notification switch change
  const handleNotifSwitch = (key) => {
    setNotificationSettings(prev => ({ ...prev, [key]: !prev[key] }));
  };

  // Password change
  const handlePasswordChange = (e) => {
    const updatedForm = { ...passwordForm, [e.target.name]: e.target.value };
    setPasswordForm(updatedForm);
    
    // Real-time validation
    const errors = validatePasswords(updatedForm);
    setPasswordValidationErrors(errors);
    
    // Clear general error when user starts typing
    if (passwordError) {
      setPasswordError("");
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    // Validate before submission
    const errors = validatePasswords(passwordForm);
    setPasswordValidationErrors(errors);
    
    if (Object.keys(errors).length > 0) {
      return;
    }
    
    setPasswordLoading(true);
    setPasswordError("");
    setPasswordSuccess("");
    const token = getOnlyToken();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    try {
      const res = await axios.post('/api/auth/change-password/', passwordForm, config);
      if (res.status === 200) {
        setSuccessMessage("Password updated successfully");
        setShowSuccessModal(true);
        setPasswordForm({ old_password: '', new_password: '', confirm_password: '' });
        setPasswordValidationErrors({});
        Navigate('/login'); // Redirect to login after password change
      }
    } catch (err) {
      // Handle different error response structures
      let errorMessage = "Failed to update password";
      
      if (err?.response?.data) {
        const errorData = err.response.data;
        
        // Check for nested detail message in results
        if (errorData.results?.detail) {
          errorMessage = errorData.results.detail;
        }
        // Check for direct message
        else if (errorData.message) {
          errorMessage = errorData.message;
        }
        // Check for direct detail
        else if (errorData.detail) {
          errorMessage = errorData.detail;
        }
      }
      
      setPasswordError(errorMessage);
    } finally {
      setPasswordLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
    fetchNotificationSettings();
    fetchSmtpDetails();
  }, []);
  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <h4 className="page-title">User Profile</h4>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-xl-4 col-lg-5">
          <div className="card text-center h-100">
            <div className="card-header text-start pb-0">
              <div className=" mb-2">
                <h4 className="header-title mb-1">User Profile</h4>
                <p className="mb-0">Manage your personal information and preferences.</p>
              </div>
            </div>
            <div className="card-body pt-2">
              <img src={previewImage ? previewImage : profile?.profile_picture_url ? profile?.profile_picture_url : "assets/images/users/avatar-1.jpg"} className="rounded-circle avatar-lg img-thumbnail" alt="profile-image" />
              <h4 className="mb-1 mt-2">{profile?.first_name ? profile?.first_name : 'User'}</h4>
              <p className=" mb-1">User</p>
              <form onSubmit={handleSubmit(profileUpdate)}>
                <div>
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    id="uploadInput"
                    onChange={handleImageUpload}
                  />
                  <button
                    type="button"
                    className="btn btn-success btn-sm mb-1"
                    onClick={() => document.getElementById('uploadInput').click()}
                  >
                    <i className="ri-upload-2-line me-1" /> Upload New Picture
                  </button>
                </div>
                <small>PNG, JPG, JPEG up to 5MB.</small>
                {/* {previewImage && (
                  <div className="mt-2">
                    <img src={previewImage} alt="Preview" style={{ width: 100, height: 100, objectFit: 'cover' }} />
                  </div>
                )} */}
                <div className="text-center mt-2">
                  <h4 className="fs-17 mb-0">Personal Information :</h4>
                  <p className="mb-3">
                    Update your name, email, and profile picture.
                  </p>
                </div>
                <div className="row text-start">
                  <div className="mb-3 col-md-6">
                    <label htmlFor="inputEmail4" className="form-label">Full name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter first name"
                      {...register('first_name', {
                        required: 'First name is required',
                        pattern: onlyAlphabetsandSpaces,
                        maxLength: MaxLengthValidation(50),
                        minLength: MinLengthValidation(2),
                      })}
                    />
                    {errors.first_name && <span className="text-danger">{errors.first_name.message}</span>}
                  </div>
                  <div className="mb-3 col-md-6">
                    <label htmlFor="inputEmail4" className="form-label">Email Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="user@aether.ai"
                      {...register('email', {
                        required: 'Email is required',
                        pattern: emailValidation,
                      })}
                    />
                    {errors.email && <span className="text-danger">{errors.email.message}</span>}
                  </div>
                  <div className="mb-3 col-md-12">
                    <label htmlFor="example-textarea" className="form-label">Bio (Optional)</label>
                    <textarea
                      className="form-control"
                      id="example-textarea"
                      rows={2}
                      placeholder="Tell us a little about yourself..."
                      {...register('bio')}
                    />
                  </div>
                  <div className="text-end"><button type="submit" className="btn btn-success">Save Changes</button></div>
                </div>
              </form>
            </div>
            {/* end card-body */}
          </div>
          {/* end card */}
        </div>
        <div className="col-xl-8  col-lg-5">
          <div className="card  h-100">
            <div className="card-header text-start pb-0">
              <div className=" mb-2">
                <h4 className="header-title mb-2">Notification</h4>
              </div>
            </div>
            <div className="card-body pt-2">
              <div className="row">
                <div className=" mb-2">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <div className>
                        <span className="font-size-22">
                          <i className=" ri-notification-2-line" />
                        </span>
                      </div>
                    </div>
                    <div className="col ps-0">
                      <h4 className=" fw-medium mb-0 font-size-18">Notification Settings</h4>
                      <p className="mb-0">Manage how you receive notifications.</p>
                    </div>
                  </div>
                </div>
                {/* Alerts/Email Notification Toggle */}
                <div className="col-xl-6  col-lg-5">
                  <div className="card mb-1 shadow-none border">
                    <div className="p-2">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <div className="avatar-sm">
                            <span className="avatar-title bg-primary-subtle  rounded">
                              <i className="ri-mail-line" />
                            </span>
                          </div>
                        </div>
                        <div className="col ps-0">
                          <h4 className="mb-1">Use Numerals</h4>
                          <p className="mb-0 font-size-13">Receive updates and alerts via email.</p>
                        </div>
                        <div className="col-auto">
                          <div className="form-check form-switch">
                            <input type="checkbox" className="form-check-input form-check-input-custom" id="customSwitchAlerts" checked={notificationSettings.alerts_status} onChange={() => handleNotifSwitch('alerts_status')} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* In-App Notification Toggle */}
                <div className="col-xl-6  col-lg-5">
                  <div className="card mb-1 shadow-none border">
                    <div className="p-2">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <div className="avatar-sm">
                            <span className="avatar-title bg-primary-subtle  rounded">
                              <i className="ri-notification-3-line" />
                            </span>
                          </div>
                        </div>
                        <div className="col ps-0">
                          <h4 className="mb-1">In-App Notifications</h4>
                          <p className="mb-0 font-size-13">Show notifications directly within the app.</p>
                        </div>
                        <div className="col-auto">
                          <div className="form-check form-switch">
                            <input type="checkbox" className="form-check-input form-check-input-custom" id="customSwitchInApp" checked={notificationSettings.in_app_notification_status} onChange={() => handleNotifSwitch('in_app_notification_status')} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Call Summary Alerts Toggle */}
                <div className="col-xl-6  col-lg-5">
                  <div className="card mb-1 shadow-none border">
                    <div className="p-2">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <div className="avatar-sm">
                            <span className="avatar-title bg-primary-subtle  rounded">
                              <i className="ri-phone-line" />
                            </span>
                          </div>
                        </div>
                        <div className="col ps-0">
                          <h4 className="mb-1">Call Summary Alerts</h4>
                          <p className="mb-0 font-size-13">Notify when a call summary is ready.</p>
                        </div>
                        <div className="col-auto">
                          <div className="form-check form-switch">
                            <input type="checkbox" className="form-check-input form-check-input-custom" id="customSwitchCallSummary" checked={notificationSettings.call_summary_status} onChange={() => handleNotifSwitch('call_summary_status')} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6  col-lg-5">
                  <div className="card mb-1 shadow-none border">
                    <div className="p-2">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <div className="avatar-sm">
                            <span className="avatar-title bg-primary-subtle  rounded">
                              <i className=" ri-lock-line" />
                            </span>
                          </div>
                        </div>
                        <div className="col ps-0">
                          <h4 className="mb-1">Two-Factor Authentication (2FA)</h4>
                          <p className="mb-0 font-size-13">Enhance your account security.</p>
                        </div>
                        <div className="col-auto">
                          <div className="form-check form-switch">
                            <input type="checkbox" className="form-check-input form-check-input-custom" id="customSwitch2fa" checked={notificationSettings.two_fa_status} onChange={() => handleNotifSwitch('two_fa_status')} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Auto Pay Toggle */}
                <div className="col-xl-6  col-lg-5">
                  <div className="card mb-1 shadow-none border">
                    <div className="p-2">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <div className="avatar-sm">
                            <span className="avatar-title bg-primary-subtle  rounded">
                              <i className="ri-bank-card-line" />
                            </span>
                          </div>
                        </div>
                        <div className="col ps-0">
                          <h4 className="mb-1">Auto Payments</h4>
                          <p className="mb-0 font-size-13">Enable or disable auto pay for your account.</p>
                        </div>
                        <div className="col-auto">
                          <div className="form-check form-switch">
                            <input type="checkbox" className="form-check-input form-check-input-custom" id="customSwitchAutoPay" checked={notificationSettings.auto_pay_status} onChange={() => handleNotifSwitch('auto_pay_status')} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6  col-lg-5">
                  <div className="row  ">
                    <h4 className="header-title mb-1 font-size-17">Privacy Settings</h4>
                    <p> Control your data and privacy preferences.</p>
                    <div className="col-xl-12  col-lg-5">
                      <div className="card mb-1 shadow-none border">
                        <div className="p-2">
                          <div className="row align-items-center">
                            <div className="col-auto">
                              <div className="avatar-sm">
                                <span className="avatar-title bg-primary-subtle  rounded">
                                  <i className=" ri-database-2-line" />
                                </span>
                              </div>
                            </div>
                            <div className="col ps-0">
                              <h4 className="mb-1">Data Sharing</h4>
                              <p className="mb-0 font-size-13">Allow AetherVoice to use anonymized data to improve services.</p>
                            </div>
                            <div className="col-auto">
                              <div className="form-check form-switch">
                                <input type="checkbox" className="form-check-input form-check-input-custom" id="customSwitchDataSharing" checked={notificationSettings.data_sharing_status} onChange={() => handleNotifSwitch('data_sharing_status')} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Save notification settings button */}
                  <div className="text-end mt-2"><button type="button" className="btn btn-success" onClick={updateNotificationSettings} disabled={notifLoading}>{notifLoading ? 'Saving...' : 'Save Changes'}</button></div>
                  {notifError && <div className="text-danger mt-2">{notifError}</div>}
                </div>
              </div>
              <div className="row">
                <div className=" col-md-6">
                  <h4 className="header-title mb-1">Account Security</h4>
                  <p> Manage your account security settings.</p>
                  <form onSubmit={handlePasswordSubmit}>
                    <label htmlFor="old_password" className="form-label">Change Password</label>
                    
                    <div className="position-relative mb-2">
                      <input 
                        type={showPasswords.old_password ? "text" : "password"} 
                        className={`form-control ${passwordValidationErrors.old_password ? 'is-invalid' : ''}`} 
                        id="old_password" 
                        name="old_password" 
                        placeholder="Current Password" 
                        value={passwordForm.old_password} 
                        onChange={handlePasswordChange} 
                      />
                      <button
                        type="button"
                        className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                        style={{ border: 'none', background: 'none', zIndex: 5 }}
                        onClick={() => togglePasswordVisibility('old_password')}
                      >
                        <i className={`ri-eye${showPasswords.old_password ? '-off' : ''}-line`}></i>
                      </button>
                      {passwordValidationErrors.old_password && (
                        <div className="invalid-feedback d-block">{passwordValidationErrors.old_password}</div>
                      )}
                    </div>

                    <div className="position-relative mb-2">
                      <input 
                        type={showPasswords.new_password ? "text" : "password"} 
                        className={`form-control ${passwordValidationErrors.new_password ? 'is-invalid' : ''}`} 
                        id="new_password" 
                        name="new_password" 
                        placeholder="New Password" 
                        value={passwordForm.new_password} 
                        onChange={handlePasswordChange} 
                      />
                      <button
                        type="button"
                        className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                        style={{ border: 'none', background: 'none', zIndex: 5 }}
                        onClick={() => togglePasswordVisibility('new_password')}
                      >
                        <i className={`ri-eye${showPasswords.new_password ? '-off' : ''}-line`}></i>
                      </button>
                      {passwordValidationErrors.new_password && (
                        <div className="invalid-feedback d-block">{passwordValidationErrors.new_password}</div>
                      )}
                    </div>

                    <div className="position-relative mb-2">
                      <input 
                        type={showPasswords.confirm_password ? "text" : "password"} 
                        className={`form-control ${passwordValidationErrors.confirm_password ? 'is-invalid' : ''}`} 
                        id="confirm_password" 
                        name="confirm_password" 
                        placeholder="Confirm Password" 
                        value={passwordForm.confirm_password} 
                        onChange={handlePasswordChange} 
                      />
                      <button
                        type="button"
                        className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                        style={{ border: 'none', background: 'none', zIndex: 5 }}
                        onClick={() => togglePasswordVisibility('confirm_password')}
                      >
                        <i className={`ri-eye${showPasswords.confirm_password ? '-off' : ''}-line`}></i>
                      </button>
                      {passwordValidationErrors.confirm_password && (
                        <div className="invalid-feedback d-block">{passwordValidationErrors.confirm_password}</div>
                      )}
                    </div>

                    {passwordError && <div className="text-danger mb-2">{passwordError}</div>}
                    {passwordSuccess && <div className="text-success mb-2">{passwordSuccess}</div>}
                    <div className="text-end mb-2">
                      <button 
                        type="submit" 
                        className="btn btn-warning btn-sm" 
                        disabled={passwordLoading || Object.keys(passwordValidationErrors).length > 0}
                      >
                        {passwordLoading ? 'Updating...' : 'Update Password'}
                      </button>
                    </div>
                  </form>
                  <div className="row">

                  </div>
                </div>

              </div>
            </div>
            {/* end card-body */}
          </div>
          {/* end card */}
        </div>
      </div>

      {/* SMTP Credentials Section (placed below profile and notifications) */}
      <div className="row mb-3">
        <div className="col-xl-12">
          <div className="card h-100">
            <div className="card-header text-start pb-0">
              <div className="mb-2">
                <h4 className="header-title mb-2">SMTP Credentials</h4>
                <p className="mb-0">Configure your SMTP server details for sending emails.</p>
              </div>
            </div>
            <div className="card-body pt-2">
              <form onSubmit={handleSmtpSubmit} autoComplete="off">
                <div className="row">
                  <div className="mb-3 col-md-4">
                    <label className="form-label">SMTP Host</label>
                    <input type="text" className="form-control" name="smpt_host" value={smtpDetails.smpt_host} onChange={handleSmtpChange} placeholder="smtp.gmail.com" required />
                  </div>
                  <div className="mb-3 col-md-2">
                    <label className="form-label">SMTP Port</label>
                    <input type="number" className="form-control" name="smpt_port" value={smtpDetails.smpt_port} onChange={handleSmtpChange} placeholder="587" required />
                  </div>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">SMTP Username</label>
                    <input type="text" className="form-control" name="smpt_username" value={smtpDetails.smpt_username} onChange={handleSmtpChange} placeholder="your-email@gmail.com" required />
                  </div>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">SMTP Password</label>
                    <input type="password" className="form-control" name="smpt_password" value={smtpDetails.smpt_password} onChange={handleSmtpChange} placeholder="App password" required autoComplete="new-password" />
                  </div>
                  <div className="mb-3 col-md-4">
                    <label className="form-label">From Email</label>
                    <input type="email" className="form-control" name="smpt_from_email" value={smtpDetails.smpt_from_email} onChange={handleSmtpChange} placeholder="your-email@gmail.com" required />
                  </div>
                  <div className="mb-3 col-md-2 d-flex align-items-center">
                    <div className="form-check form-switch mt-4">
                      <input type="checkbox" className="form-check-input form-check-input-custom" id="customSwitchTls" name="use_tls" checked={smtpDetails.use_tls} onChange={handleSmtpChange} />
                      <label className="form-check-label ms-2" htmlFor="customSwitchTls">Use TLS</label>
                    </div>
                  </div>
                </div>
                {smtpError && <div className="text-danger mb-2">{smtpError}</div>}
                <div className="text-end">
                  <button type="submit" className="btn btn-success" disabled={smtpLoading}>{smtpLoading ? 'Saving...' : smtpId ? 'Update SMTP Details' : 'Save SMTP Details'}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal for all success messages */}
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>{successMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowSuccessModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>

  )
}
